import { useQuery } from 'react-query'
import { NestAPI, useGetBusiness } from '@marketing-milk/frontend'
import { CreativeImportProgress } from '@marketing-milk/interfaces'
import { isTerminalJobStatus } from './state'

/** Polls import progress every 2s until the job reaches a terminal status. */
export const useCreativeImportProgress = (creativeImportID: number | null, enabled: boolean) => {
  const business = useGetBusiness()

  return useQuery<CreativeImportProgress>(
    ['creative-import-progress', business.id, creativeImportID],
    async () => {
      const response = await NestAPI.get<CreativeImportProgress>(
        `businesses/${business.id}/creative-import/${creativeImportID}`
      )
      return response.data
    },
    {
      enabled: enabled && creativeImportID !== null,
      refetchInterval: data => (data && isTerminalJobStatus(data.status) ? false : 2000),
    }
  )
}
